import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
/**
 * <h4>Example of Button Model:</h4>
 * <pre>{{'{'}}
 * 	label: 'Buy',
 * 	iconProperty: {{'{'}}
 * 		name: 'fa-money'
 *  {{'}'}}
 *  iconPosition: 'right'
 * {{'}'}}</pre>
 */
export class ButtonModel extends CoreModel {
/**
 * <p>Label on the button</p>
 * <p>Default is <b>BTN</b></p>
 */
label?: string;
/**
 * <p>Type of the button</p>
 * <p>Default is <b>button</b></p>
 */
type?: string;
/**
 * <p> Icon object on the button</p>
 * <p> Refer to Icon Component</p>
 */
iconProperty?: IconModel;
/**
 * <p>Position of the icon (Left of Right)</p>
 */
iconPosition?: string;
/**
 * <p>Collection of needed AM Button visual types like: mat-primary, mat-raised-button, mat-fab, etc. </p>
 */
buttonTheme?: string;
/**
 * <p>Waiting state of the button
 * <p>Button can be in that state  whether enabled or disabled</p>
 */
waiting?: {
  /**
   * <p>Property to toggle button in/out of 'waiting' state</p>
   */
    value: boolean;
    /**
     * <p>Disable button when it is in 'waiting' state</p>
     */
    disabled: boolean;
    /**
     * <p>Icon representing button in 'waiting' state</p>
     */
    iconProperty: IconModel;
  };
/**
 * @hidden 
 * It is the constructor for the button component. It takes the required string values to create the button object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ButtonModel_tsickle_Closure_declarations() {
/**
 * <p>Label on the button</p>
 * <p>Default is <b>BTN</b></p>
 * @type {?}
 */
ButtonModel.prototype.label;
/**
 * <p>Type of the button</p>
 * <p>Default is <b>button</b></p>
 * @type {?}
 */
ButtonModel.prototype.type;
/**
 * <p> Icon object on the button</p>
 * <p> Refer to Icon Component</p>
 * @type {?}
 */
ButtonModel.prototype.iconProperty;
/**
 * <p>Position of the icon (Left of Right)</p>
 * @type {?}
 */
ButtonModel.prototype.iconPosition;
/**
 * <p>Collection of needed AM Button visual types like: mat-primary, mat-raised-button, mat-fab, etc. </p>
 * @type {?}
 */
ButtonModel.prototype.buttonTheme;
/**
 * <p>Waiting state of the button
 * <p>Button can be in that state  whether enabled or disabled</p>
 * @type {?}
 */
ButtonModel.prototype.waiting;
}

